var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "p-5"
};
const _hoisted_3 = { class: "subtitle" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = { class: "column" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Username", -1);
const _hoisted_7 = { class: "column" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Registered", -1);
const _hoisted_9 = { class: "columns" };
const _hoisted_10 = { class: "column" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Partner", -1);
const _hoisted_12 = { class: "column" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Site", -1);
const _hoisted_14 = { class: "columns" };
const _hoisted_15 = { class: "column" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Case Worker", -1);
const _hoisted_17 = { class: "level is-mobile" };
const _hoisted_18 = { class: "level-left" };
const _hoisted_19 = { key: 1 };
const _hoisted_20 = {
    key: 0,
    class: "pt-1"
};
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Ambassador", -1);
const _hoisted_22 = { class: "column" };
const _hoisted_23 = {
    key: 0,
    class: "columns"
};
const _hoisted_24 = { class: "column" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Active Applications", -1);
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { class: "column" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Other Services / Interventions", -1);
const _hoisted_30 = {
    key: 0,
    class: "column"
};
const _hoisted_31 = { class: "message is-small is-danger" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Network Admin Controls")
], -1);
const _hoisted_33 = { class: "message-body" };
const _hoisted_34 = { class: "column" };
const _hoisted_35 = { class: "message is-small is-link" };
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Partner Controls")
], -1);
const _hoisted_37 = { class: "message-body" };
const _hoisted_38 = { class: "columns" };
const _hoisted_39 = { class: "column" };
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Key Documents", -1);
const _hoisted_41 = { class: "column" };
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Additional Documents / Support", -1);
const _hoisted_43 = { key: 2 };
const _hoisted_44 = { class: "horizontal" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Citizen Profile", -1);
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-eye mr-3" }, null, -1);
const _hoisted_47 = { class: "columns" };
const _hoisted_48 = { class: "columns is-mobile" };
const _hoisted_49 = { class: "columns" };
const _hoisted_50 = { class: "columns is-mobile" };
const _hoisted_51 = { class: "columns is-mobile" };
const _hoisted_52 = { class: "column" };
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Demographics", -1);
const _hoisted_54 = { class: "column" };
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Needs", -1);
const _hoisted_56 = { key: 3 };
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Attachments", -1);
const _hoisted_58 = { class: "column" };
const _hoisted_59 = { class: "label" };
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_61 = { key: 4 };
const _hoisted_62 = { key: 5 };
const _hoisted_63 = { key: 6 };
const _hoisted_64 = { key: 7 };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Housing", -1);
const _hoisted_66 = { class: "columns" };
const _hoisted_67 = { class: "column" };
const _hoisted_68 = { class: "column" };
const _hoisted_69 = { key: 8 };
const _hoisted_70 = { class: "columns" };
const _hoisted_71 = { class: "columns" };
const _hoisted_72 = { class: "column field" };
const _hoisted_73 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Message", -1);
const _hoisted_74 = { class: "control" };
import TypeAhead from "@/components/TypeAhead.vue";
import ListEditor from "@/components/ListEditor.vue";
import { useAsync } from "@/composables/useAsync";
import { Validations, useValidation } from "@/composables/useValidation";
import { doApiAction } from "@/core/api";
import { ProfileTypes, CitizenInterventions, Feature, Core } from '@minicity/core';
import { isFeatureEnabled, isNetworkAdmin, proxyLoginAsCitizenUser, sessionState } from "@/core/session";
import { enumKey, formatDateShort, formatDateTime, notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import ApplicationBadge from "@/features/applications/ApplicationBadge.vue";
import CitizenChecksBanner from "@/features/citizens/checks/CitizenChecksBanner.vue";
import EquifaxDigitalIdentityTrustIndicator from "@/features/citizens/checks/EquifaxDigitalIdentityTrustIndicator.vue";
import CitizenClassifiersPanel from "@/features/citizens/classifiers/CitizenClassifiersPanel.vue";
import CitizenLift20SummaryPanel from "@/features/lift_2_0/components/CitizenLift20SummaryPanel.vue";
import { apiCitizenChecks } from "@/features/citizens/checks/api";
import { apiPartnerUsers } from "@/features/partnerUsers/api";
import { computed, onMounted, ref, reactive, watch } from "vue";
import { apiCitizens } from "./api";
import { apiCitizenInterventions } from "./interventions/api";
import CitizenInterventionEditorModal from "./interventions/CitizenInterventionEditorModal.vue";
import { watchQueryParam } from "@/composables/watchQueryParam";
import FormSelectField from "@/components/FormSelectField.vue";
import KeyDocumentCard from "./KeyDocumentCard.vue";
var Tab;
(function (Tab) {
    Tab["DETAILS"] = "Citizen Details";
    Tab["ATTACHMENTS"] = "Attachments";
    Tab["COMMENTS"] = "Comments";
    Tab["TASKS"] = "Tasks";
    Tab["CLASSIFIERS"] = "Classifiers";
    Tab["HOUSING"] = "Housing";
    Tab["LIFT_2_0"] = "LIFT 2.0";
})(Tab || (Tab = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'CitizenDetailPanel',
    props: {
        citizenId: {}
    },
    setup(__props) {
        const props = __props;
        const citizen = useAsync();
        const citizenChecks = useAsync();
        const citizenInterventions = useAsync();
        const allCaseworkers = useAsync();
        const loadCitizen = () => {
            citizen.fetch(apiCitizens.get(props.citizenId))
                .then(cit => {
                allCaseworkers.fetch(apiPartnerUsers.getForPartner(cit.assignedCareProvider.id))
                    .catch(err => notifyNetworkError("Failed to load caseworkers", err));
            })
                .catch(err => notifyNetworkError("Failed to load citizen", err));
            if (isFeatureEnabled(Feature.Type.EQUIFAX_CHECKS)) {
                citizenChecks.fetch(apiCitizenChecks.getForCitizen(props.citizenId), "Failed to load citizen checks");
            }
            loadInterventions();
        };
        onMounted(() => {
            if (!sessionState.session)
                return; // We should only be here if we're logged-in
            loadCitizen();
            if (new URL(window.location.toString()).searchParams.has('taskId')) {
                activeTab.value = Tab.TASKS;
            }
        });
        // Tabs
        const activeTab = ref(Tab.DETAILS);
        watch(activeTab, watchQueryParam(activeTab, 'tab'));
        // Form validation
        const { areAllFieldsValid, validator } = useValidation();
        // UI state
        const inProgressAction = ref(null);
        const reassigningToCaseWorker = ref(null);
        // Actions
        const saveProfile = () => {
            if (!areAllFieldsValid.value) {
                notifyError("Please check for invalid form inputs");
                return;
            }
            doApiAction(inProgressAction, 'saveProfile', "Profile saved", "Failed to update citizen profile", () => apiCitizens.setProfile(citizen.data.id, citizen.data.profile));
        };
        const saveHmisId = () => {
            if (!citizen.data.hmisId)
                return;
            doApiAction(inProgressAction, 'saveHmisId', "HMIS ID saved", "Failed to save HMIS ID", () => apiCitizens.setHmisId(citizen.data.id, citizen.data.hmisId).then(() => loadCitizen()));
        };
        const saveHousingReadinessLocation = () => {
            doApiAction(inProgressAction, 'saveHousingReadinessLocation', "Housing Readiness location saved", "Failed to save Housing Readiness location", () => apiCitizens.setHousingReadinessLocation(citizen.data.id, citizen.data.housingReadinessLocation).then(() => loadCitizen()));
        };
        const saveHousingReadinessType = () => {
            doApiAction(inProgressAction, 'saveHousingReadinessType', "Housing Readiness type saved", "Failed to save Housing Readiness type", () => apiCitizens.setHousingReadinessType(citizen.data.id, citizen.data.housingReadinessType).then(() => loadCitizen()));
        };
        const interventionEditor = ref(null);
        const loadInterventions = () => {
            citizenInterventions.fetch(apiCitizenInterventions.getForCitizen(props.citizenId));
        };
        const docTypes = {
            'SIGNATURE': 'Signature',
            'VERIFICATION_SELFIE': 'Verification Selfie'
        };
        const deleteDocument = (doc, type) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `deleteDocument`;
            apiCitizens.deleteAttachment(citizen.data.id, doc.id)
                .then(() => {
                delete citizen.data.attachments[type];
                notifySuccess("Document deleted");
            })
                .catch(err => notifyNetworkError("Failed to delete document", err))
                .finally(() => inProgressAction.value = null);
        };
        const uploadDocument = (uploadInfo, type) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `uploadDocument`;
            apiCitizens.uploadAttachment(citizen.data.id, type, uploadInfo.file)
                .then(doc => {
                citizen.data.attachments[type] = doc;
                notifySuccess("Document uploaded");
            })
                .catch(err => notifyNetworkError("Failed to upload document", err))
                .finally(() => {
                inProgressAction.value = null;
                uploadInfo.onDone();
            });
        };
        const downloadDocument = (doc) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `downloadDocument`;
            apiCitizens.getAttachmentViewLink(citizen.data.id, doc.id)
                .then((attachmentViewLink) => window.open(attachmentViewLink))
                .catch(err => notifyNetworkError("Failed to download attachment", err))
                .finally(() => inProgressAction.value = null);
        };
        const setKeyDocumentStatus = (docType, status) => {
            const keyDoc = citizen.data.keyDocuments[docType];
            return apiCitizens.setKeyDocumentStatus(citizen.data.id, docType, status)
                .then(() => { keyDoc.status = status; });
        };
        const uploadKeyDocument = (docType, file) => {
            const keyDoc = citizen.data.keyDocuments[docType];
            return apiCitizens.uploadAttachment(citizen.data.id, docType, file)
                .then(doc => { keyDoc.attachments.push(doc); });
        };
        const deleteKeyDocument = (docType, id) => {
            const keyDoc = citizen.data.keyDocuments[docType];
            return apiCitizens.deleteAttachment(citizen.data.id, id)
                .then(() => { keyDoc.attachments = keyDoc.attachments.filter((d) => d.id != id); });
        };
        const getKeyDocumentViewLink = (id) => {
            return apiCitizens.getAttachmentViewLink(citizen.data.id, id);
        };
        const allCaseworkersExceptSelf = computed(() => citizen.status != 'ready' || allCaseworkers.status != 'ready' ? [] : allCaseworkers.data.filter((pu) => pu.id != citizen.data.assignedCaseworker.id));
        const reassignCaseWorker = (caseworker) => {
            reassigningToCaseWorker.value = caseworker;
        };
        const doReassignCaseWorker = (caseworker) => {
            apiCitizens.setCaseworker(citizen.data.id, caseworker.id)
                .then(() => {
                citizen.data.assignedCaseworker = caseworker;
                notifySuccess("Caseworker Reassigned");
            })
                .catch(err => {
                notifyNetworkError("Failed to reassign caseworker", err);
            })
                .finally(() => {
                reassigningToCaseWorker.value = null;
            });
        };
        const passwordResetState = reactive({
            displayed: false,
            password: "",
            repeatPassword: ""
        });
        const resetPassword = () => {
            if (!(Validations.notEmpty(passwordResetState.password) && passwordResetState.password.length >= 8 && passwordResetState.password == passwordResetState.repeatPassword)) {
                notifyError("Please make sure the passwords match, and are at least 8 characters long");
                return;
            }
            inProgressAction.value = `resetPassword`;
            apiCitizens.setPassword(citizen.data.id, passwordResetState.password)
                .then(() => {
                notifySuccess("Password reset successfully!");
                passwordResetState.displayed = false;
            })
                .catch(() => {
                notifyError("Password reset failed");
            })
                .finally(() => {
                inProgressAction.value = null;
            });
        };
        const sendNotificationState = reactive({
            displayed: false,
            useEmail: false,
            useSMS: false,
            subject: "",
            body: ""
        });
        const sendNotification = () => {
            if (!sendNotificationState.useEmail && !sendNotificationState.useSMS) {
                notifyError("Please select email and/or SMS");
                return;
            }
            if (!Validations.notEmpty(sendNotificationState.body)) {
                notifyError("Please enter a message");
                return;
            }
            inProgressAction.value = `sendNotification`;
            apiCitizens.sendNotification(citizen.data.id, sendNotificationState.useEmail, sendNotificationState.useSMS, sendNotificationState.subject, sendNotificationState.body)
                .then(() => {
                notifySuccess("Notification sent successfully!");
                sendNotificationState.displayed = false;
                sendNotificationState.subject = "";
                sendNotificationState.body = "";
            })
                .catch(() => {
                notifyError("Notification sending failed");
            })
                .finally(() => {
                inProgressAction.value = null;
            });
        };
        const proxyLogin = () => {
            doApiAction(inProgressAction, "proxyLogin", "Logged-in as user", "Failed to login as user", () => proxyLoginAsCitizenUser(citizen.data.id).then((url) => window.open(url, '_blank')));
        };
        const downloadIdentityReportPDF = () => {
            doApiAction(inProgressAction, "downloadIdentityReportPdf", null, "Failed to download PDF", () => __awaiter(this, void 0, void 0, function* () {
                yield apiCitizenChecks.getIdentityReportPdfViewLink(citizen.data.id)
                    .then((pdfViewLink) => window.open(pdfViewLink));
            }));
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            const _component_SiteBadge = _resolveComponent("SiteBadge");
            const _component_UserBadge = _resolveComponent("UserBadge");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_HeaderSectionLayout = _resolveComponent("HeaderSectionLayout");
            const _component_TabsHeader = _resolveComponent("TabsHeader");
            const _component_FormDateField = _resolveComponent("FormDateField");
            const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_TaskSection = _resolveComponent("TaskSection");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            const _component_FormCheckboxField = _resolveComponent("FormCheckboxField");
            return (_unref(isFeatureEnabled)('CITIZENS'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_unref(citizen).status == 'loading')
                        ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                        : (_unref(citizen).status == 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_unref(citizenChecks).status == 'loading')
                                    ? (_openBlock(), _createBlock(_component_LoadingSpinner, {
                                        key: 0,
                                        size: "small"
                                    }))
                                    : (_unref(citizenChecks).status == 'ready')
                                        ? (_openBlock(), _createBlock(CitizenChecksBanner, {
                                            key: 1,
                                            checks: _unref(citizenChecks).data
                                        }, null, 8, ["checks"]))
                                        : _createCommentVNode("", true),
                                _createVNode(_component_HeaderSectionLayout, null, {
                                    title: _withCtx(() => [
                                        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(citizen).data.displayName), 1)
                                    ]),
                                    fields: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _hoisted_6,
                                                _createElementVNode("p", null, _toDisplayString(_unref(citizen).data.username), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _hoisted_8,
                                                _createElementVNode("p", null, _toDisplayString(_unref(formatDateTime)(_unref(citizen).data.registeredAt)), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _createElementVNode("div", _hoisted_10, [
                                                _hoisted_11,
                                                _createVNode(_component_PartnerBadge, {
                                                    partner: _unref(citizen).data.assignedCareProvider
                                                }, null, 8, ["partner"])
                                            ]),
                                            _createElementVNode("div", _hoisted_12, [
                                                _hoisted_13,
                                                _createVNode(_component_SiteBadge, {
                                                    site: _unref(citizen).data.assignedSite
                                                }, null, 8, ["site"])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _hoisted_16,
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        (_unref(citizen).data.assignedCaseworker)
                                                            ? (_openBlock(), _createBlock(_component_UserBadge, {
                                                                key: 0,
                                                                user: _unref(citizen).data.assignedCaseworker,
                                                                class: "mr-3"
                                                            }, null, 8, ["user"]))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_19, "None")),
                                                        (_unref(allCaseworkers).data)
                                                            ? (_openBlock(), _createBlock(TypeAhead, {
                                                                key: 2,
                                                                "prop-data": allCaseworkersExceptSelf.value,
                                                                onItemSelected: _cache[0] || (_cache[0] = ($event) => (reassignCaseWorker($event))),
                                                                placeholder: "Type to reassign...",
                                                                icon: "fas fa-user",
                                                                labelField: "displayName"
                                                            }, null, 8, ["prop-data"]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]),
                                                (_unref(isFeatureEnabled)(_unref(Feature).Type.AMBASSADOR_PROGRAM))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                        _hoisted_21,
                                                        _createElementVNode("span", null, _toDisplayString(_unref(citizen).data.assignedAmbassador || 'None'), 1)
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                _createVNode(_component_FormTextField, {
                                                    label: "HMIS ID",
                                                    placeholder: "Not enrolled",
                                                    modelValue: _unref(citizen).data.hmisId,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(citizen).data.hmisId) = $event)),
                                                    class: "pl-0"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_SaveButton, {
                                                            label: _unref(citizen).data.hmisId ? 'Update' : 'Enroll',
                                                            icon: "fa-save",
                                                            action: "saveHmisId",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[1] || (_cache[1] = ($event) => (saveHmisId()))
                                                        }, null, 8, ["label", "inProgressAction"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue"])
                                            ])
                                        ]),
                                        (_unref(isNetworkAdmin)())
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    _hoisted_25,
                                                    _createElementVNode("ul", null, [
                                                        (_unref(citizen).data.activeApplications.length == 0)
                                                            ? (_openBlock(), _createElementBlock("li", _hoisted_26, "None"))
                                                            : _createCommentVNode("", true),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizen).data.activeApplications, (application) => {
                                                            return (_openBlock(), _createElementBlock("li", {
                                                                key: application.id
                                                            }, [
                                                                _createVNode(ApplicationBadge, { application: application }, null, 8, ["application"])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_27, [
                                                    (_unref(citizenInterventions).status == 'loading')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                            _hoisted_29,
                                                            _createVNode(_component_LoadingSpinner)
                                                        ]))
                                                        : (_unref(citizenInterventions).status == 'ready')
                                                            ? (_openBlock(), _createBlock(ListEditor, {
                                                                key: 1,
                                                                items: _unref(citizenInterventions).data,
                                                                headerLabel: "Other Services / Interventions",
                                                                itemLabel: (item) => `${_unref(formatDateShort)(item.occurredAt)} - ${_unref(enumKey)(item.interventionType, _unref(CitizenInterventions).InterventionType)}`,
                                                                noneLabel: "None",
                                                                hideActionLabels: "",
                                                                addLabel: "Add",
                                                                onAdd: () => interventionEditor.value.create(),
                                                                onEdit: (idx) => interventionEditor.value.edit(_unref(citizenInterventions).data[idx]),
                                                                onRemove: (idx) => interventionEditor.value.delete(_unref(citizenInterventions).data[idx])
                                                            }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"]))
                                                            : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    networkAdminControls: _withCtx(() => [
                                        (_unref(isNetworkAdmin)())
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                _createElementVNode("article", _hoisted_31, [
                                                    _hoisted_32,
                                                    _createElementVNode("div", _hoisted_33, [
                                                        _createVNode(_component_SaveButton, {
                                                            label: "Send Notification",
                                                            icon: "fa-envelope",
                                                            onClick: _cache[3] || (_cache[3] = ($event) => (sendNotificationState.displayed = true))
                                                        }),
                                                        _createVNode(_component_SaveButton, {
                                                            label: "Login As This User",
                                                            icon: "fa-sign-in-alt",
                                                            action: "proxyLogin",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[4] || (_cache[4] = ($event) => (proxyLogin()))
                                                        }, null, 8, ["inProgressAction"])
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    partnerControls: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("article", _hoisted_35, [
                                                _hoisted_36,
                                                _createElementVNode("div", _hoisted_37, [
                                                    _createVNode(_component_SaveButton, {
                                                        label: "Reset Password",
                                                        icon: "fa-key",
                                                        onClick: _cache[5] || (_cache[5] = ($event) => (passwordResetState.displayed = true))
                                                    })
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _: 1
                                }),
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _hoisted_40,
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['BIRTH_RECORD', 'SOCIAL_SECURITY', 'STATE_ID'], (docType) => {
                                            return _createVNode(KeyDocumentCard, {
                                                key: docType,
                                                class: "mb-4",
                                                keyDocumentType: docType,
                                                keyDocument: _unref(citizen).data.keyDocuments[docType],
                                                setStatus: (s) => setKeyDocumentStatus(docType, s),
                                                uploadAttachment: (file) => uploadKeyDocument(docType, file),
                                                deleteAttachment: (id) => deleteKeyDocument(docType, id),
                                                getAttachmentViewLink: (id) => getKeyDocumentViewLink(id)
                                            }, null, 8, ["keyDocumentType", "keyDocument", "setStatus", "uploadAttachment", "deleteAttachment", "getAttachmentViewLink"]);
                                        }), 64))
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                        _hoisted_42,
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['VETERAN_ID', 'GEORGIA_DFCS_BENEFITS'], (docType) => {
                                            return _createVNode(KeyDocumentCard, {
                                                key: docType,
                                                class: "mb-4",
                                                keyDocumentType: docType,
                                                keyDocument: _unref(citizen).data.keyDocuments[docType],
                                                setStatus: (s) => setKeyDocumentStatus(docType, s),
                                                uploadAttachment: (file) => uploadKeyDocument(docType, file),
                                                deleteAttachment: (id) => deleteKeyDocument(docType, id),
                                                getAttachmentViewLink: (id) => getKeyDocumentViewLink(id)
                                            }, null, 8, ["keyDocumentType", "keyDocument", "setStatus", "uploadAttachment", "deleteAttachment", "getAttachmentViewLink"]);
                                        }), 64))
                                    ])
                                ]),
                                _createVNode(_component_TabsHeader, {
                                    modelValue: activeTab.value,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((activeTab).value = $event)),
                                    tabs: Tab,
                                    entityType: _unref(Core).EntityType['Citizen'],
                                    entityId: _unref(citizen).data.id
                                }, null, 8, ["modelValue", "entityType", "entityId"]),
                                (activeTab.value == Tab.DETAILS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                            _hoisted_45,
                                            _createElementVNode("a", {
                                                class: _normalizeClass(["button is-link ml-5 mb-5", { 'is-loading': inProgressAction.value == 'downloadIdentityReportPdf' }]),
                                                onClick: _cache[7] || (_cache[7] = ($event) => (downloadIdentityReportPDF()))
                                            }, [
                                                _hoisted_46,
                                                _createTextVNode(" Download Identity Report PDF ")
                                            ], 2)
                                        ]),
                                        _createElementVNode("div", _hoisted_47, [
                                            _createVNode(_component_FormTextField, {
                                                label: "First Name *",
                                                modelValue: _unref(citizen).data.profile.firstName,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(citizen).data.profile.firstName) = $event)),
                                                validator: _unref(validator)(_unref(Validations).notEmpty)
                                            }, {
                                                top: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createVNode(EquifaxDigitalIdentityTrustIndicator, {
                                                            check: (_a = _unref(citizenChecks).data) === null || _a === void 0 ? void 0 : _a.equifaxDigitalIdentityTrust,
                                                            category: "identity",
                                                            label: "name / identity"
                                                        }, null, 8, ["check"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue", "validator"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Middle Name",
                                                modelValue: _unref(citizen).data.profile.middleName,
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(citizen).data.profile.middleName) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Last Name *",
                                                modelValue: _unref(citizen).data.profile.lastName,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(citizen).data.profile.lastName) = $event)),
                                                validator: _unref(validator)(_unref(Validations).notEmpty)
                                            }, null, 8, ["modelValue", "validator"])
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                            _createVNode(_component_FormTextField, {
                                                label: "Phone",
                                                modelValue: _unref(citizen).data.profile.phoneNumber,
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(citizen).data.profile.phoneNumber) = $event))
                                            }, {
                                                top: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createVNode(EquifaxDigitalIdentityTrustIndicator, {
                                                            check: (_a = _unref(citizenChecks).data) === null || _a === void 0 ? void 0 : _a.equifaxDigitalIdentityTrust,
                                                            category: "phone",
                                                            label: "phone number"
                                                        }, null, 8, ["check"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "Email",
                                                modelValue: _unref(citizen).data.profile.email,
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_unref(citizen).data.profile.email) = $event))
                                            }, {
                                                top: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createVNode(EquifaxDigitalIdentityTrustIndicator, {
                                                            check: (_a = _unref(citizenChecks).data) === null || _a === void 0 ? void 0 : _a.equifaxDigitalIdentityTrust,
                                                            category: "email",
                                                            label: "email address"
                                                        }, null, 8, ["check"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_49, [
                                            _createVNode(FormSelectField, {
                                                label: "Race / Ethnicity",
                                                modelValue: _unref(citizen).data.profile.race,
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(citizen).data.profile.race) = $event)),
                                                options: _unref(ProfileTypes).Race,
                                                validator: _unref(validator)(_unref(Validations).notEmpty)
                                            }, null, 8, ["modelValue", "options", "validator"]),
                                            _createVNode(FormSelectField, {
                                                label: "Sex / Gender",
                                                modelValue: _unref(citizen).data.profile.sex,
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(citizen).data.profile.sex) = $event)),
                                                options: _unref(ProfileTypes).Sex,
                                                validator: _unref(validator)(_unref(Validations).notEmpty)
                                            }, null, 8, ["modelValue", "options", "validator"])
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                            _createVNode(_component_FormDateField, {
                                                label: "Date Of Birth",
                                                modelValue: _unref(citizen).data.profile.dateOfBirth,
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(citizen).data.profile.dateOfBirth) = $event)),
                                                validator: _unref(validator)(_unref(Validations).notEmpty),
                                                past: ""
                                            }, {
                                                top: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createVNode(EquifaxDigitalIdentityTrustIndicator, {
                                                            check: (_a = _unref(citizenChecks).data) === null || _a === void 0 ? void 0 : _a.equifaxDigitalIdentityTrust,
                                                            category: "dob",
                                                            label: "date of birth"
                                                        }, null, 8, ["check"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue", "validator"]),
                                            _createVNode(_component_FormTextField, {
                                                label: "SSN",
                                                length: 9,
                                                modelValue: _unref(citizen).data.profile.socialSecurityNumber,
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(citizen).data.profile.socialSecurityNumber) = $event))
                                            }, {
                                                top: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createVNode(EquifaxDigitalIdentityTrustIndicator, {
                                                            check: (_a = _unref(citizenChecks).data) === null || _a === void 0 ? void 0 : _a.equifaxDigitalIdentityTrust,
                                                            category: "ssn",
                                                            label: "Social Security number"
                                                        }, null, 8, ["check"])
                                                    ];
                                                }),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                                _hoisted_53,
                                                _createElementVNode("ul", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizen).data.preferences.demographics, (demographic) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: demographic }, _toDisplayString(demographic), 1));
                                                    }), 128))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_54, [
                                                _hoisted_55,
                                                _createElementVNode("ul", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(citizen).data.preferences.needs, (need) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: need }, _toDisplayString(need), 1));
                                                    }), 128))
                                                ])
                                            ])
                                        ]),
                                        _createVNode(_component_SaveButton, {
                                            label: "Save Profile",
                                            icon: "fa-save",
                                            action: "saveProfile",
                                            inProgressAction: inProgressAction.value,
                                            onClick: _cache[17] || (_cache[17] = ($event) => (saveProfile()))
                                        }, null, 8, ["inProgressAction"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.ATTACHMENTS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                        _hoisted_57,
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(docTypes, (docTypeLabel, docTypeId) => {
                                            return _createElementVNode("div", {
                                                class: "columns is-multiline",
                                                key: docTypeId
                                            }, [
                                                _createElementVNode("div", _hoisted_58, [
                                                    _createElementVNode("label", _hoisted_59, _toDisplayString(docTypeLabel), 1),
                                                    _createVNode(_component_DocumentUploadWidget, {
                                                        singleDocument: _unref(citizen).data.attachments[docTypeId],
                                                        onDelete: ($event) => (deleteDocument($event, docTypeId)),
                                                        onUpload: ($event) => (uploadDocument($event, docTypeId)),
                                                        onView: _cache[18] || (_cache[18] = ($event) => (downloadDocument($event)))
                                                    }, null, 8, ["singleDocument", "onDelete", "onUpload"])
                                                ]),
                                                _hoisted_60
                                            ]);
                                        }), 64))
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.COMMENTS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                        _createVNode(_component_CommentSection, {
                                            getComments: () => _unref(apiCitizens).getComments(_unref(citizen).data.id),
                                            addComment: (message, attachments, notifyCaseworker) => _unref(apiCitizens).addComment(_unref(citizen).data.id, message, attachments, notifyCaseworker),
                                            getAttachmentViewLink: (commentId, attachmentId) => _unref(apiCitizens).getCommentAttachmentViewLink(_unref(citizen).data.id, commentId, attachmentId)
                                        }, null, 8, ["getComments", "addComment", "getAttachmentViewLink"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.TASKS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                        _createVNode(_component_TaskSection, {
                                            allowShowAll: "",
                                            getTasks: () => _unref(apiCitizens).getTasks(_unref(citizen).data.id),
                                            addTask: (audience, message) => _unref(apiCitizens).addTask(_unref(citizen).data.id, audience, message)
                                        }, null, 8, ["getTasks", "addTask"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.CLASSIFIERS)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                        _createVNode(CitizenClassifiersPanel, {
                                            citizenId: _unref(citizen).data.id
                                        }, null, 8, ["citizenId"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.HOUSING)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                        _hoisted_65,
                                        _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("div", _hoisted_67, [
                                                _createVNode(FormSelectField, {
                                                    label: "Housing Readiness Location",
                                                    options: { 'Pryor Street': 'PRYOR_STREET' },
                                                    modelValue: _unref(citizen).data.housingReadinessLocation,
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(citizen).data.housingReadinessLocation) = $event)),
                                                    allowNullSelection: "",
                                                    nullSelectionLabel: "-- None --",
                                                    class: "pl-0"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_SaveButton, {
                                                            label: "Update",
                                                            icon: "fa-save",
                                                            action: "saveHousingReadinessLocation",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[19] || (_cache[19] = ($event) => (saveHousingReadinessLocation()))
                                                        }, null, 8, ["inProgressAction"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_68, [
                                                _createVNode(FormSelectField, {
                                                    label: "Housing Readiness Type",
                                                    options: { 'Rapid Rehousing': 'RAPID_REHOUSING', 'Permanent Supportive Housing': 'PERMANENT_SUPPORTIVE_HOUSING' },
                                                    modelValue: _unref(citizen).data.housingReadinessType,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(citizen).data.housingReadinessType) = $event)),
                                                    allowNullSelection: "",
                                                    nullSelectionLabel: "-- None --",
                                                    class: "pl-0"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_SaveButton, {
                                                            label: "Update",
                                                            icon: "fa-save",
                                                            action: "saveHousingReadinessType",
                                                            inProgressAction: inProgressAction.value,
                                                            onClick: _cache[21] || (_cache[21] = ($event) => (saveHousingReadinessType()))
                                                        }, null, 8, ["inProgressAction"])
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue"])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (activeTab.value == Tab.LIFT_2_0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                        _createVNode(CitizenLift20SummaryPanel, {
                                            citizen: _unref(citizen).data
                                        }, null, 8, ["citizen"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                    _createVNode(_component_ModalDialog, {
                        active: reassigningToCaseWorker.value != null,
                        title: "Change Caseworker Assignment",
                        severity: "link",
                        allowClose: true,
                        onClose: _cache[23] || (_cache[23] = ($event) => (reassigningToCaseWorker.value = null)),
                        firstButtonText: "Cancel",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[24] || (_cache[24] = ($event) => (reassigningToCaseWorker.value = null)),
                        secondButtonText: "Reassign",
                        secondButtonSeverity: "link",
                        onSecondbuttonselected: _cache[25] || (_cache[25] = ($event) => (doReassignCaseWorker(reassigningToCaseWorker.value)))
                    }, {
                        default: _withCtx(() => {
                            var _a, _b;
                            return [
                                _createElementVNode("p", null, [
                                    _createElementVNode("strong", null, "Do you wish to reassign citizen " + _toDisplayString((_a = _unref(citizen).data) === null || _a === void 0 ? void 0 : _a.displayName) + " to caseworker " + _toDisplayString((_b = reassigningToCaseWorker.value) === null || _b === void 0 ? void 0 : _b.displayName) + "?", 1)
                                ])
                            ];
                        }),
                        _: 1
                    }, 8, ["active"]),
                    _createVNode(_component_ModalDialog, {
                        active: passwordResetState.displayed,
                        loading: inProgressAction.value == 'resetPassword',
                        title: "Reset Citizen Password",
                        severity: "link",
                        allowClose: true,
                        onClose: _cache[28] || (_cache[28] = ($event) => (passwordResetState.displayed = false)),
                        "first-button-text": "Reset Citizen Password",
                        "first-button-severity": "link",
                        onFirstbuttonselected: _cache[29] || (_cache[29] = ($event) => (resetPassword()))
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_70, [
                                    _createVNode(_component_FormTextField, {
                                        label: "Please enter the citizen's new password",
                                        placeholder: "Password",
                                        isPassword: true,
                                        modelValue: passwordResetState.password,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((passwordResetState.password) = $event))
                                    }, null, 8, ["modelValue"])
                                ]),
                                _createElementVNode("div", _hoisted_71, [
                                    _createVNode(_component_FormTextField, {
                                        label: "Repeat Password",
                                        placeholder: "Repeat Password",
                                        isPassword: true,
                                        modelValue: passwordResetState.repeatPassword,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((passwordResetState.repeatPassword) = $event))
                                    }, null, 8, ["modelValue"])
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["active", "loading"]),
                    _createVNode(_component_ModalDialog, {
                        active: sendNotificationState.displayed,
                        loading: inProgressAction.value == 'sendNotification',
                        title: "Send Notification",
                        severity: "link",
                        allowClose: true,
                        onClose: _cache[34] || (_cache[34] = ($event) => (sendNotificationState.displayed = false)),
                        "first-button-text": "Send",
                        "first-button-severity": "link",
                        onFirstbuttonselected: _cache[35] || (_cache[35] = ($event) => (sendNotification()))
                    }, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d;
                            return [
                                _createElementVNode("div", null, [
                                    _createVNode(_component_FormCheckboxField, {
                                        boxLabel: `Send via email (${((_a = _unref(citizen).data) === null || _a === void 0 ? void 0 : _a.preferences.notifications.email) || 'Not available'})`,
                                        isDisabled: !((_b = _unref(citizen).data) === null || _b === void 0 ? void 0 : _b.preferences.notifications.email),
                                        modelValue: sendNotificationState.useEmail,
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((sendNotificationState.useEmail) = $event))
                                    }, null, 8, ["boxLabel", "isDisabled", "modelValue"]),
                                    _createVNode(_component_FormCheckboxField, {
                                        boxLabel: `Send via SMS (${((_c = _unref(citizen).data) === null || _c === void 0 ? void 0 : _c.preferences.notifications.sms) || 'Not available'})`,
                                        isDisabled: !((_d = _unref(citizen).data) === null || _d === void 0 ? void 0 : _d.preferences.notifications.sms),
                                        modelValue: sendNotificationState.useSMS,
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((sendNotificationState.useSMS) = $event))
                                    }, null, 8, ["boxLabel", "isDisabled", "modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                        label: "Subject",
                                        modelValue: sendNotificationState.subject,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((sendNotificationState.subject) = $event))
                                    }, null, 8, ["modelValue"]),
                                    _createElementVNode("div", _hoisted_72, [
                                        _hoisted_73,
                                        _createElementVNode("div", _hoisted_74, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                class: "textarea",
                                                label: "Message",
                                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((sendNotificationState.body) = $event))
                                            }, null, 512), [
                                                [_vModelText, sendNotificationState.body]
                                            ])
                                        ])
                                    ])
                                ])
                            ];
                        }),
                        _: 1
                    }, 8, ["active", "loading"]),
                    _createVNode(CitizenInterventionEditorModal, {
                        ref_key: "interventionEditor",
                        ref: interventionEditor,
                        citizenId: _ctx.citizenId,
                        onModified: loadInterventions
                    }, null, 8, ["citizenId"])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
